import { Button, DialogActions, DialogContent, DialogTitle } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function ConfirmDialog({
    message,
    title,
    ok,
    cancel,
    buttons,
    okText = "Ok",
    okColor = "primary",
    okIcon,
    cancelIcon,
}) {
    return (
        <div onKeyDown={stopEnterPropagation}>
            {title && <DialogTitle data-cy="confirm-dialog-title">{title}</DialogTitle>}
            <DialogContent data-cy="confirm-dialog-content" sx={{ mt: 2 }}>
                {message}
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={cancel}
                    color="secondary"
                    startIcon={cancelIcon ? <Iconify icon={cancelIcon} /> : undefined}
                    data-cy="confirm-dialog-cancel"
                >
                    Cancel
                </Button>
                {buttons ? (
                    buttons.map((b) => (
                        <Button key={b} onClick={() => ok(b)} color="primary">
                            {b}
                        </Button>
                    ))
                ) : (
                    <Button
                        onClick={() => ok(true)}
                        color={okColor}
                        variant="contained"
                        startIcon={okIcon ? <Iconify icon={okIcon} /> : undefined}
                        id="confirmOkButton"
                        data-cy="dialogActionsOkButton"
                        autoFocus
                    >
                        {okText}
                    </Button>
                )}
            </DialogActions>
        </div>
    )

    function stopEnterPropagation(event) {
        if (event.key === "Enter") {
            event.stopPropagation()
        }
    }
}
